












































































































































import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { CommentListTableMixin } from "./mixins";
import { ReceptionComment, ReceptionCommentSet } from "../../../../domain/workflow/reception";
import { ReceptionCommentKinds } from "../../../../domain/workflow/kinds";

import CommentTable from "./controles/CommentTable.vue";
import CommentDialog from "../../dialogs/CommentDialog.vue";

@Component({
  components: {
    CommentTable,
  }
})
export default class CommentListTable extends Mixins(CommentListTableMixin) {
  @Prop()
  commentDialog: CommentDialog;

  mounted() {
    this.initializeSortTypes();
  }

  showCommentDialog(kind: ReceptionCommentKinds, title: string, comment: ReceptionComment, commentSet: ReceptionCommentSet): void {
    (this.commentDialog)
      .show(
        this.toCommentDialogCondition(
          title,
          (comment ? comment.content : ""),
          commentSet
        )
      )
      .then(d => {
        if (d.isConfirmed) {
          if (comment) {
            comment.content = d.note;
          } else {
            comment = new ReceptionComment();
            comment.content = d.note;
          }
          this.registerComment(kind, comment);
        }
      });
  }

  async confirmDeleteComment(kind: ReceptionCommentKinds): Promise<number> {
    return this.$commonDialogs.confirmation.show({
      title: "削除確認",
      message: [this.getCommentLabel(kind) + "を削除してもよろしいですか？"],
      buttons: [
        {
          kind: "danger",
          label: "削除する",
        }
      ],
      cancellation: {
        isEnable: true,
        label: this.cancelButtonLabel,
      },
    });
  }

  private initializeSortTypes(): void {
    this.nextMessageSortType = this.commentDefaultSortType;
    this.commentSortType = this.commentDefaultSortType;
    this.backMessageSortType = this.commentDefaultSortType;
    this.conflictCommentSortType = this.commentDefaultSortType;
    this.restrictCommentSortType = this.commentDefaultSortType;
    this.contactedInfoSortType = this.commentDefaultSortType;
    this.delCommentSortType = this.commentDefaultSortType;
  }

  @Watch("detailId")
  onDetailIdChanged() {
    this.initializeSortTypes();
  }

  @Watch("commentSetting")
  onCommentSettingUpdated() {
    this.initializeSortTypes();
  }
}
